/*
 * Require all scripts here and they will be bundled by Rollup
 * - Wrapping the scripts in an IIFE to create a local scope is not neccessary
 * - Including 'use strict' in the scripts is not neccessary and should be left out
 * - ES2015 sytax is available and will be compiled to ES5 for compatibility
 */

require('@babel/polyfill');
require('smooth-scrolling');
require('./polyfills');
require('./a11y');
require('./animated-header');
require('./auto-slide');
require('./contact-form');
require('./credit-form');
require('./default-nav');
require('./global-stoerer');
require('./lightbox');
require('./newsletter-form');
require('./scroll-indicator');
require('./slider');
require('./smooth-scroll-to-fragment-links');
require('./support-form');
require('./video-popup');
require('./product-overview');
require('./animated-mood-images');
// Presets


document.addEventListener('DOMContentLoaded', function() {
  const windowWidth = window.innerWidth;
  const featureNavActive = document.querySelector('.feature-nav-active');
  const featureNavUl = document.querySelector('.feature-nav-ul');
  const container = document.querySelector('.feature-nav-wrapper');
  //windowWidth >= featureNavUl?.offsetWidth
  if(!featureNavActive) {
    return;
  }

  const activeElement = container.querySelector('.feature-nav-active');

  // Scroll the container to the active element
  container.scrollLeft = activeElement.offsetLeft;
});
